import styled from "styled-components"

import { Heading } from "../../../component-library/design/typography/typography.styles"

const StyledHeading = styled(Heading)`
  margin-bottom: 18px;
`

export { StyledHeading }
